/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

import { NativeModules } from 'react-native';
const { JedAIModule } = NativeModules;

export class PageTracker {

    /**
     * Enter page.
     * @param pageName Name of the page.
     * @returns `Promise` with no parameters.
     */
    enterPage(pageName: string): Promise<void> {
        return JedAIModule.enterPage(pageName);
    }

    /**
     * Exit page.
     * @returns `Promise` with no parameters.
     */
    exitPage(): Promise<void> {
        return JedAIModule.exitPage()
    }

}